import * as React from "react";
import { useEffect, useState, useMemo } from "react";
import { useDataProvider } from "react-admin";
import useAiInsight from "../../../Components/AiAssistant/useAiInsight";
import { buildAiBaseParams } from "../../../Components/AiAssistant/buildAiBaseParams";
import { Typography } from "@material-ui/core";
import GaugeChart from "../../../Components/CustomChart/GaugeChart";

const CockpitCapability = ({ filterParams }) => {
  const dataProvider = useDataProvider();

  const [chartValue, setChartValue] = useState(0);

  const resourceEndpoint = "pbhrequestorders/cockpit/capability";

  const subArcs = [
    {
      limit: 70,
      color: "#EA4228",
      showTick: true,
    },
    {
      limit: 100,
      color: "#5BE12C",
      showTick: true,
    },
  ];

  const insightParams = useMemo(() => {
    if (chartValue === 0) return null;
    return {
      ...buildAiBaseParams(filterParams),
      capabilityRate: chartValue.toFixed(2),
    };
  }, [filterParams, chartValue]);
  useAiInsight("cockpitcapability", insightParams);

  useEffect(() => {
    GetChartData();
  }, [filterParams]);

  const GetChartData = async () => {
    await dataProvider
      .getList(resourceEndpoint, {
        pagination: { page: 1, perPage: 999999 },
        sort: { field: "id", order: "ASC" },
        filter: filterParams,
      })
      .then(({ data }) => {
        const sum = data.reduce((sum, current) => sum + current.inCap, 0);
        const avg = Number(((sum / data.length) * 100).toFixed(2));
        setChartValue(avg);
      })
      .catch(error => {
        console.log(error);
      });
  };

  return (
    <>
      <Typography gutterBottom variant="h5" component="h2" align="center">
        Capability Rate
      </Typography>
      <GaugeChart value={chartValue} subArcs={subArcs} />
      <br />
      <br />
    </>
  );
};

export default CockpitCapability;
